// @flow
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styles from './PreprodWarningBanner.module.scss';

type Props = {};

const PreprodWarningBanner = () => {
    return (
        <div className={styles.banner}>
            <div className={styles['banner-inner']}>
                <div className={styles.text}>
                    <FormattedMessage id="preprod_warning_banner_text" />
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(PreprodWarningBanner);
